<template>
  <div class="card">
    <div class="card-header">
      <h2>Media & Content</h2>
    </div>
    <div class="card-body">
      <div class="form-grid">
        <div class="form-field">
          <label for="science_behind_it">Science Behind It Video URL</label>
          <input 
            id="science_behind_it"
            :value="modelValue.science_behind_it"
            @input="updateField('science_behind_it', $event.target.value)"
            type="url"
            placeholder="Enter video URL"
          >
        </div>
        
        <div class="form-field">
          <label for="audio_url">Audio URL</label>
          <input 
            id="audio_url"
            :value="modelValue.audio_url"
            @input="updateField('audio_url', $event.target.value)"
            type="url"
            placeholder="Enter audio URL"
          >
        </div>
      
        <div class="form-field">
          <label for="audio_url_ar">Audio URL (Arabic)</label>
          <input 
            id="audio_url_ar"
            :value="modelValue.audio_url_ar"
            @input="updateField('audio_url_ar', $event.target.value)"
            type="url"
            placeholder="Enter Arabic audio URL"
          >
        </div>
        
        <div class="form-field">
          <label for="audio_cover">Audio Cover URL</label>
          <input 
            id="audio_cover"
            :value="modelValue.audio_cover"
            @input="updateField('audio_cover', $event.target.value)"
            type="url"
            placeholder="Enter audio cover URL"
          >
        </div>
      
        <div class="form-field">
          <label for="audio_cover_ar">Audio Cover URL (Arabic)</label>
          <input 
            id="audio_cover_ar"
            :value="modelValue.audio_cover_ar"
            @input="updateField('audio_cover_ar', $event.target.value)"
            type="url"
            placeholder="Enter Arabic audio cover URL"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaContentCard',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    updateField(field, value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [field]: value
      });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.card-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-body {
  padding: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.form-field input {
  height: 2.75rem;
  padding: 0 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: white;
  font-size: 0.875rem;
  color: #1e293b;
  transition: all 0.2s ease;
}

.form-field input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.form-field input:hover {
  border-color: #9ca3af;
}
</style> 